export const buildPlantName = (prefix, number) =>
  [prefix, number].filter(Boolean).join("-");

export const getPersonLabel = (person) =>
  typeof person === "object"
    ? person?.name || person?.email || "-"
    : person || "-";

/**
 * A plant's WBS as a list - the API returns `projects` (array) or, on older
 * records, a single `project`.
 */
export const plantWbsList = (plant) => {
  const wbs = plant?.projects || plant?.project;
  if (Array.isArray(wbs)) return wbs;
  return wbs ? [wbs] : [];
};

/**
 * WBS count shown for a plant: only the WBS written for this deployment's
 * client (REACT_APP_CLIENT_NAME) - the same rows the WBS dialog manages.
 */
export const countPlantWbs = (plant) =>
  plantWbsList(plant).filter(
    (wbs) => wbs && wbs.clientName === process.env.REACT_APP_CLIENT_NAME,
  ).length;
